import {SECCIONES} from "../Constantes";
import {scrolearAComponente} from "./scrolearAComponente";
import {useNavigate} from "react-router-dom";

export const useIrRuta = ({funcionUno = null}) => {
    const navigate = useNavigate()

    const ir = (secc) => {

        switch (secc) {
            case SECCIONES[0]:
                if (funcionUno !== null && funcionUno !== undefined) {
                    funcionUno()
                }
                break
            case SECCIONES[1]:
                navigate('/Contactos')
                break
            case SECCIONES[2]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente(SECCIONES[2])
                }, 500)
                break
            case SECCIONES[3]:
                navigate('/Nosotros')
                break
        }
    }

    return {
        ir
    }


}